
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import { BORDER_RADIUS_LABELS, BorderRadius } from "@/types/singularity/brand";
import ButtonGroup from "../../components/ButtonGroup.vue";

@Component({
  components: {
    ButtonGroup
  }
})
export default class BrandToggleFontSizes extends Vue {
  update(radius: BorderRadius) {
    this.$emit("update", radius);
  }

  @Prop()
  value!: BorderRadius[];

  get radiusesWithLabels() {
    return this.value.map(radius => ({
      label: BORDER_RADIUS_LABELS[radius],
      value: radius
    }));
  }

  get currentRatio() {
    return singularityStore.brand.ui.inputRadius;
  }
}
